import React from 'react'
import ButtonLoader from './ButtonLoader'
import { Button } from '@mui/material'

type Props = {
  onClick?: any
  children: string | any
  className?: string
  type?: 'button' | 'submit' | 'reset' | undefined
  disabled?: any
  loader?: boolean
  variant?: 'contained' | 'outlined'
  // Pass-through to the underlying MUI <Button>. `style` lets callers override
  // background/border for status-coloured buttons (green Activate, red Disable);
  // `title` surfaces a native hover-tooltip for context (e.g. "Select a form first"
  // when a button is disabled).
  style?: React.CSSProperties
  title?: string
}

const CustomButton = (props: Props) => {
  const { onClick, children, className, type, disabled, loader, variant, style, title } = props
  return (
    <Button
      variant={variant || 'contained'}
      sx={{
        bgcolor: variant === 'outlined' ? '' : 'primary.main',
        color: variant === 'outlined' ? 'text.secondary' : 'white',
        borderColor: variant === 'outlined' ? 'divider' : undefined,
        '&:hover': {
          bgcolor: variant === 'outlined' ? 'primary.tones.50' : 'primary.dark',
          color: variant === 'outlined' ? 'primary.main' : undefined,
          borderColor: variant === 'outlined' ? 'primary.main' : undefined,
        },
      }}
      style={style}
      title={title}
      disabled={disabled || loader}
      type={type}
      onClick={onClick}
      className={`!min-h-10 !rounded-lg !px-4 !py-2 !text-[13px] !font-semibold !normal-case ${disabled || loader ? '!relative cursor-not-allowed ' : ''} ${loader ? 'disabled:opacity-75 !text-transparent' : ''} ${className || ''}`}
    >
      {loader && <ButtonLoader />}
      {children}
    </Button>
  )
}

export default CustomButton

// import React from 'react'
// import ButtonLoader from './ButtonLoader'
// import { Button } from '@mui/material'

// type Props = {
//   onClick?: any
//   children: string | any
//   className?: string
//   type?: 'button' | 'submit' | 'reset' | undefined
//   disabled?: any
//   loader?: boolean
//   sx?: any
// }

// const CustomButton = (props: Props) => {
//   const { onClick, children, className, type, disabled, loader, sx } = props
//   return (
//     <Button
//       size="large"
//       sx={{
//         textTransform: 'none',
//         ...(sx || {}),
//       }}
//       // color="primary"
//       variant="contained"
//       disabled={disabled || loader}
//       type={type}
//       onClick={onClick}
//       // className={`font-medium bg-secondary text-white py-3 px-6 rounded-md shadow-sm hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-secondary ${disabled || loader ? 'relative !text-secondary cursor-not-allowed ' : ''} ${loader ? ' disabled:opacity-75' : ''} ${className}`}
//       className={`!font-semibold !py-2.5 shadow-sm focus:outline-none ${disabled || loader ? 'relative !text-transparent cursor-not-allowed ' : ''} ${loader ? ' ' : ''} ${className}`}
//     >
//       {loader && <ButtonLoader />}
//       {children}
//     </Button>
//   )
// }

// export default CustomButton
